module.exports = __webpack_public_path__ + "img/02_content_02@2x.ce0dc92b.png";